import type { ConstsConfig } from '../declare'

const consts: ConstsConfig[] = [
  {
    name: 'USER_ROLE_SUPER',
    value: 100
  },
  {
    name: 'USER_TYPE_ADMINISTRATOR',
    value: 99
  }
]

export default consts